import React, { useEffect, useState } from "react";

import { useHistory, useParams } from "react-router-dom";

import { Flex, Button, SimpleGrid, Box, Text } from "@chakra-ui/react";

import LoadingSpinner from "../../../components/LoadingSpinner";
import Group from "../Visualizar/Group";

import SemRegistros from "../../../components/SemRegistros";
import {
  criancaFunc,
  Permission,
  servicoAcolhimentoFunc,
} from "../../../../helpers/Funcionalidades";
import { useAuthProvider } from "../../../../Context/AuthProvider";
import { useAppContext } from "../../../../Context/MessageContextProvider";
import ServicoAcolhimentoService from "../../../../main/services/ServicoAcolhimentoService";

const VisualizarApadrinhamentoServico = () => {
  const { id } = useParams();
  const history = useHistory();
  const { roleKeycloack, user } = useAuthProvider();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState();
  const { idPJ } = useAppContext();

  useEffect(() => {
    ServicoAcolhimentoService.getProgramaApadrinhamentoServico(id)
      .then((res) => {
        setLoading(false);
        setData(res.data);
      })
      .catch((erro) => {
        if (erro.response) {
          if (erro.response.data.status === 404) {
            history.push(`/servico-acolhimento/cadastrar-apadrinhamento/${id}`);
          }
        }
      });
  }, [history, id]);

  return !loading && data ? (
    <>
      {roleKeycloack &&
      (roleKeycloack.includes(
        servicoAcolhimentoFunc.visualizarApadrinhamentoServ
      ) ||
        ((roleKeycloack?.includes(criancaFunc.visualizarTudoAcolhimento) ||
          roleKeycloack?.includes(criancaFunc.visualizarTudoTutelar)) &&
          user?.orgaoExterno?.includes(idPJ))) ? (
        <>
          <Group title="Programa de Apadrinhamento">
            <Flex mt="17px" direction={"column"} gap="18px">
              <Box>
                <Text as="b">Serviço Mantém Programa de Apadrinhamento? </Text>
                <Text>
                  {data.mantemProgramaApadrinhamento === "S" ? "Sim" : "Não"}
                </Text>
              </Box>

              {data.mantemProgramaApadrinhamento === "S" && (
                <Box>
                  <Text as="b">
                    Em Caso Positivo, esse Programa se Encontra Inscrito no
                    CMDCA?{" "}
                  </Text>
                  <Text>
                    {data.programaInscritoCmdca === "S" ? "Sim" : "Não"}
                  </Text>
                </Box>
              )}
            </Flex>
          </Group>

          <SimpleGrid
            mt="30px"
            columns={{ base: 1, sm: 2, lg: 5 }}
            spacing="20px"
            dir="rtl"
          >
            <Permission
              roleKeycloack={roleKeycloack}
              func={servicoAcolhimentoFunc.editarApadrinhamentoServ}
              id={idPJ}
              user={user}
            >
              <Button
                id="button-editar"
                color="#FFF"
                backgroundColor="#169499"
                fontWeight={700}
                fontSize="15px"
                lineHeight="21.6px"
                _hover={{ bg: "#169499" }}
                onClick={() => {
                  history.push(
                    `/servico-acolhimento/editar-apadrinhamento/${id}`
                  );
                }}
              >
                Editar
              </Button>
            </Permission>
          </SimpleGrid>
        </>
      ) : (
        <Box mt="2">
          <SemRegistros half buttonVisible={true} />
        </Box>
      )}
    </>
  ) : (
    <Flex w="100%" mt="25%" justifyContent="center">
      <LoadingSpinner />
    </Flex>
  );
};

export default VisualizarApadrinhamentoServico;
